import { spriteSize } from "~/src/consts/sizes";

export const processRadiusCollision = (radius: number) => (
  obj1: Phaser.GameObjects.GameObject,
  obj2: Phaser.GameObjects.GameObject
) => Phaser.Math.Distance.BetweenPoints(
  (obj1 as Phaser.Physics.Arcade.Sprite).body.center!,
  (obj2 as Phaser.Physics.Arcade.Sprite).body.center!
) <= radius;

export default processRadiusCollision(spriteSize / 2);
